import { format, isBefore, startOfDay } from 'date-fns';

import { SHORT_TIME_FORMAT } from '@/utils/constants';

type Period = { start: string; end: string };

export type FormattedPeriod = {
  startObj: Date;
  endObj: Date;
  startTime: string;
  endTime: string;
};

const getEffectiveStart = (startObj: Date, now: Date): Date => {
  const isOngoing = isBefore(startOfDay(startObj), startOfDay(now));

  if (isOngoing) {
    return startOfDay(now);
  }

  return startObj;
};

export const formatPeriod = (period: Period, now: Date): FormattedPeriod => {
  const startObj = new Date(period.start);
  const endObj = new Date(period.end);
  const effectiveStart = getEffectiveStart(startObj, now);

  return {
    startObj: effectiveStart,
    endObj,
    startTime: format(effectiveStart, SHORT_TIME_FORMAT),
    endTime: format(endObj, SHORT_TIME_FORMAT),
  };
};
